import React from 'react';
import SearchBar from './searchbar';
import PeripheralList from './peripheralList';
import { get_version, x2xxPlats } from '../../utes/appUtils';
import './peripheralTable.css';
import PeripheralRow from "./peripheralList/peripheralRow";


class FilterablePeripheralTable extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            filterText: '',
            checked: false,
        };
        this.handleFilterTextChange = this.handleFilterTextChange.bind(this);
        this.handleInStockChange = this.handleInStockChange.bind(this);

    }

    handleFilterTextChange(filterText) {
        this.setState({
            filterText: filterText
        });
    }

    handleInStockChange(inStockOnly) {
        this.setState({
            inStockOnly: inStockOnly
        })
    }

    render() {
        let tmc_color = (this.props.TMCDisabled)? 'grey':'black';
        return (

            <div className="filterable-list">
                <p>
                {x2xxPlats.includes(get_version(this.props.selectedBoard)) && <label
                    title={"Check this box when using TMC"}
                    style={{float:'left', fontWeight:'normal', color: tmc_color}}>
                  <input

                    type="checkbox"
                    checked={this.props.TMCActive}
                    onChange={this.props.TMCCallback}
                    disabled={this.props.TMCDisabled || this.state.disabled}
                  />
                  &nbsp; TMC pin pulled up
                </label>}
                &nbsp;&nbsp;
                </p>
                <SearchBar
                    filterText={this.state.filterText}
                    inStockOnly={this.state.inStockOnly}
                    onFilterTextChange={this.handleFilterTextChange}
                    onInStockChange={this.handleInStockChange}
                />
                <PeripheralList filterText={this.state.filterText}>
                    {this.props.peripherals.filter((peri) => {
                        return peri.name.indexOf(this.state.filterText) !== -1
                    }).map((peri) => {
                        let isActive = false;
                        let isRequired = ((peri.name === 'qspi') && (this.props.QSPIrequired));
                        if (peri.name === 'gpio'){
                            isActive = peri.pinIO.some((value)=>{
                                return value !== 0;
                            });
                        }
                        else{
                            isActive = peri.pinSelection.some((value)=>{
                                return (value !== null)&&(value!==-1);
                            });
                        }
                        return <PeripheralRow peri={peri}
                                                active={isActive}
                                                required={isRequired}
                                                selected={peri.selected}
                                                key={peri.name}
                                                clickCallback={this.props.clickListCallback} />
                    }


                    )}
                </PeripheralList>
            </div>
        );
    }
}

export default FilterablePeripheralTable;
